import {memo, type ReactNode} from 'react';

interface MarqueeProps {
    /** The items, rendered once per copy. */
    children: ReactNode;
    /** Extra class on the outer wrapper (spacing). */
    className?: string;
    /** Extra class on each moving row (the gap between items). */
    trackClassName?: string;
}

const cx = (...names: Array<string | false | undefined>) => names.filter(Boolean).join(' ');

/**
 * An endless left-scrolling strip (logos, platforms), paused on hover. The items are rendered twice so the loop is
 * seamless; the second copy is hidden from screen readers. The animation itself is the site-wide
 * `.banner-bottom-container` rule in globals.scss (40s), which the legacy pages still share; it moves into this atom
 * once those pages are converted.
 */
const Marquee = ({children, className, trackClassName}: MarqueeProps) => (
    <div className={cx('banner-bottom-container-wrapper', className)}>
        <div className={cx('banner-bottom-container', trackClassName)}>{children}</div>
        <div className={cx('banner-bottom-container', trackClassName)} aria-hidden="true">
            {children}
        </div>
    </div>
);

export default memo(Marquee);
